import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { map } from 'rxjs/operators';
import { ZoningCode } from '../../../models/zoning-code';
import { ZoningCodeService } from '../../../services';
import IZoningCodeRecord = ZoningAPI.IZoningCodeRecord;

@Component({
    standalone: false,
    selector: 'app-update-zc-status-button',
    templateUrl: './update-zc-status-button.component.html',
    styleUrls: ['./update-zc-status-button.component.scss']
})
export class UpdateZcStatusButtonComponent implements OnInit {
    @Input()
    zoningCode: ZoningCode;

    @Input()
    needWindowReload = true;

    @Input()
    updateZCRecord = true;

    @Input()
    getDefaultDSC: boolean = false;

    @Input()
    stateEnv: string;

    @Output()
    updatedZoningCode = new EventEmitter<IZoningCodeRecord>();

    constructor(private readonly zoningCodeService: ZoningCodeService) {}

    ngOnInit(): void {}

    updateZCStatus() {
        return this.zoningCodeService
            .updateZoningCodeStatus(this.zoningCode, this.stateEnv, {
                syncStatistic: true,
                syncZCStatus: true,
                updateZCRecord: this.updateZCRecord,
                getDefaultDSC: this.getDefaultDSC,
                syncZCMissedEntitiesStatistic: true,
                syncStatByZCStatuses: true,
                syncPerformanceStatistic: true,
                syncSolrData: true
            })
            .pipe(
                map(zoningCode => {
                    this.updatedZoningCode.emit(zoningCode);
                    /**
                     * TODO :: Right now there is no mechanism of correct updating Zoning Come model for
                     * updateZoningCodeStatus - data will be cleared in the end.
                     * The easiest way is to reload the page to get new data.
                     * In future we definitely should changes that.
                     */
                    if (this.needWindowReload) {
                        window.location.reload();
                    }
                    return true;
                })
            );
    }
}
